const a = {
  robot01: {
    name: "walking robot",
    img: "avatar-de-robot-1.png",
    category: "robots"
  },
  robot02: {
    name: "robot teacher",
    img: "avatar-de-robot-2.png",
    category: "robots"
  },
  robot03: {
    name: "robot dog",
    img: "avatar-de-robot-3.png",
    category: "robots"
  },
  robot04: {
    name: "wheelchair robot",
    img: "avatar-de-robot-4.png",
    category: "robots"
  },
  robot05: {
    name: "robot rabbit",
    img: "avatar-de-robot-5.png",
    category: "robots"
  },
  robot06: {
    name: "confused robot",
    img: "avatar-de-robot-6.png",
    category: "robots"
  },
  robot07: {
    name: "robot gramps",
    img: "avatar-de-robot-7.png",
    category: "robots"
  },
  robot08: {
    name: "happy robot",
    img: "avatar-de-robot-8.png",
    category: "robots"
  },
  coding01: {
    name: "vampire cartoon",
    img: "avatar-coding-1.png",
    category: "cartoons"
  },
  coding02: {
    name: "spider cartoon",
    img: "avatar-coding-2.png",
    category: "cartoons"
  },
  coding03: {
    name: "bee cartoon",
    img: "avatar-coding-3.png",
    category: "cartoons"
  },
  coding04: {
    name: "tortoise cartoon",
    img: "avatar-coding-4.png",
    category: "cartoons"
  },
  coding05: {
    name: "panda cartoon",
    img: "avatar-coding-5.png",
    category: "cartoons"
  },
  coding06: {
    name: "elephant cartoon",
    img: "avatar-coding-6.png",
    category: "cartoons"
  },
  coding07: {
    name: "rocket cartoon",
    img: "avatar-coding-7.png",
    category: "cartoons"
  },
  coding08: {
    name: "plane cartoon",
    img: "avatar-coding-8.png",
    category: "cartoons"
  },
  animal01: {
    name: "lemur photo",
    img: "avatar-animals-01.png",
    category: "animals"
  },
  animal02: {
    name: "spider photo",
    img: "avatar-animals-02.png",
    category: "animals"
  },
  animal03: {
    name: "turtle photo",
    img: "avatar-animals-03.png",
    category: "animals"
  },
  animal04: {
    name: "dog photo",
    img: "avatar-animals-04.png",
    category: "animals"
  },
  animal05: {
    name: "shark photo",
    img: "avatar-animals-05.png",
    category: "animals"
  },
  animal06: {
    name: "cat photo",
    img: "avatar-animals-06.png",
    category: "animals"
  },
  animal07: {
    name: "bird photo",
    img: "avatar-animals-07.png",
    category: "animals"
  },
  animal08: {
    name: "lion photo",
    img: "avatar-animals-08.png",
    category: "animals"
  },
  dinosaur01: {
    name: "scientifically inaccurate dinosaur toy",
    img: "avatar-dinosaur-1.png",
    category: "dinosaurs"
  },
  dinosaur02: {
    name: "pachycephalosaurus",
    img: "avatar-dinosaur-2.png",
    category: "dinosaurs"
  },
  dinosaur03: {
    name: "deinonychus",
    img: "avatar-dinosaur-3.png",
    category: "dinosaurs"
  },
  dinosaur04: {
    name: "carnotaurus",
    img: "avatar-dinosaur-4.png",
    category: "dinosaurs"
  },
  dinosaur05: {
    name: "the same scientifically inaccurate dinosaur toy at a different angle",
    img: "avatar-dinosaur-5.png",
    category: "dinosaurs"
  },
  dinosaur06: {
    name: "t-rex skull",
    img: "avatar-dinosaur-6.png",
    category: "dinosaurs"
  },
  dinosaur07: {
    name: "t-rex",
    img: "avatar-dinosaur-7.png",
    category: "dinosaurs"
  },
  dinosaur08: {
    name: "velociraptor",
    img: "avatar-dinosaur-8.png",
    category: "dinosaurs"
  },
  illustration01: {
    name: "synth glasses illustration",
    img: "avatar-illustrations-01.png",
    category: "illustrations"
  },
  illustration02: {
    name: "hypno cat illustration",
    img: "avatar-illustrations-02.png",
    category: "illustrations"
  },
  illustration03: {
    name: "sea man illustration",
    img: "avatar-illustrations-03.png",
    category: "illustrations"
  },
  illustration04: {
    name: "cab driver illustration",
    img: "avatar-illustrations-04.png",
    category: "illustrations"
  },
  illustration05: {
    name: "dog rapper illustration",
    img: "avatar-illustrations-05.png",
    category: "illustrations"
  },
  illustration06: {
    name: "mermaid illustration",
    img: "avatar-illustrations-06.png",
    category: "illustrations"
  },
  illustration07: {
    name: "picasso face illustration",
    img: "avatar-illustrations-07.png",
    category: "illustrations"
  },
  illustration08: {
    name: "frogman illustration",
    img: "avatar-illustrations-08.png",
    category: "illustrations"
  },
  default: {
    name: "generic silhouette",
    img: "avatar-generic.png"
  }
};
function i(o, t) {
  const r = t || window.paths.core_static, n = a[o] || a.default;
  return `${r}apps/students/avatars/${n.img}`;
}
const g = {
  AVATARS: a,
  avatarImagePath: i
};
export {
  a as AVATARS,
  i as avatarImagePath,
  g as default
};
